import { careerImg } from '../../images';

export const data = {
  image: careerImg,
};

export default { data };
